<template>
  <div class="menuMore" :style="{ 'paddingTop': statusBar - 0.04 + 'rem' }" ref="menuMorePaddingTop">
    <Headerd v-if="headerShow" title="国际贸易单一窗口标准版" :white="true" :paddingTopHeight="statusBar" ref="headheight" />
    <div class="menuMoremain">
      <div class="list" style="margin-top:10px">
        <div v-for="(item, i) in this.menuList" :key="i" style="margin:6px 0;background:#fff " ref='i'>
          <div class="BiztypeDetailbg" style="border-bottom:1px solid #f3f7ff">
            <div class="BiztypeDetail" style="margin-top:6px;border-bottom:1px solid #f3f7ff">
              <p>{{ item.appBiztypeName }}</p>
            </div>
          </div>
          <ul>
            <li v-for="(v, index) in item.arr" :key="index" @click="gotoSmall(v.appUrl, v.appId)"
              :class="[index % 4 === 0 ? 'borderLeft' : '', item.arr.length % 4 === 0 ? ((item.arr.length - 5) <= i ? 'borderBottom' : '') : ((item.arr.length - (item.arr.length % 4)) <= i ? 'borderBottom' : '')]">
              <img v-if="v.appIcon" :src="v.appIcon" alt class="imgApp" style="width: 24px;height: 24px;">
              <img v-if="v.isNew === '1'" class="newImg" src="@/views/image/icon_new_application.png" alt />
              <img v-if="v.isHot === '1'" class="newImg" src="@/views/image/icon_hot_application.png" alt />
              <span v-html="v.appName"></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/views/css/resetVui.scss";
import "./menu.scss";
import Headerd from "@/components/Headerd";
import {
  Grid,
  GridItem,
  Tab,
  Tabs,
  Sticky,
  Col,
  Row,
  Collapse,
  CollapseItem,
} from "vant";
export default {
  name: "home",
  /**
   * 初始化数据
   */
  data() {
    return {
      tabHeight: 0,
      menuList: [],
      statusBar: 0,
      statusBars: 0,
      backormoren: true,
      isLoad: "0",
      myAppHeight: "",
      headerShow: true,
      active: 0,
      collapseName: [],
      showp: "展开",
      shownn: "1",
      kong: [],
    };
  },
  /**
   * 初始化
   */
  mounted() {
    this.statusBar = this.$tool.statusBar(42);
    this.statusBars = this.$tool.statusBar(274);
    this.$refs.menuMorePaddingTop.style.paddingTop = this.statusBar + "rem";
    window.backData = this.backData;
    this.getMobileApps();
    window.getMyselfApps = this.getMyselfApps;
    window.addEventListener("scroll", this.handleScroll, true);
  },
  watch: {
    collapseName() {
      if (this.collapseName[0] == 1) {
        this.showp = "收起";
      } else {
        this.showp = "展开";
      }
    },
    //路由回调刷新
    statusBar() {
      this.headerShow = false;
      this.$nextTick(function () {
        this.statusBar = this.$tool.statusBar(42);
        this.headerShow = true;
      });
    },
  },

  /**
   * 方法
   */
  methods: {
    BrmyListFunction() {
      for (let i in this.menuList) {
        for (let j in this.menuList[i].arr) {
          this.menuList[i].arr[j].appName = this.menuList[i].arr[
            j
          ].appName.replace(/\|\|/g, "<br/>");
        }
      }
    },
    handleScroll() {
      let centerhei = document.documentElement.clientHeight / 2;
      for (var a = 0; a < this.$refs.i.length; a++) {
        let _pos = this.$refs.i[a].getBoundingClientRect().top;
        if (_pos < centerhei + 5 && _pos > centerhei - 5) {
          this.active = a;
        }
      }
    },
    backData(val) {
      this.statusBar = val;
      sessionStorage.setItem("statusBar", val);
    },

    /**
     * 跳转小应用
     */
    gotoSmall(val, id) {
      this.$http1.get("/zsdyckserver/app/access/" + id).then((res) => {
        console.log(res);
      });
      let arr = val.split(":");
      if (arr[0] === "js") {
        this.$tool.callModule(arr[1]);
      } else {
        if (val === "") {
          // this.$toast('敬请期待哟！');
        } else {
          window.location.href = `${window.location.origin}/${val}`;
          // this.$tool.sessionData('#1e3cd2', 'true');
        }
      }
    },
    /**
     * 获取首页menu数据
     */
    getMobileApps() {
      this.$http.post("/zsdyckserver/app/getAllMobileApps").then((res) => {
        if (res.resultFlag === "1") {
          this.menuList = this.filterMenu(
            this.dataRecom(res.resultData.allApp)
          );
          console.log(this.filterMenu(this.dataRecom(res.resultData.allApp)));
          this.BrmyListFunction();
        }
      });
    },
    /**
     * 数据重组 By kongxiangcheng
     */
    dataRecom(values) {
      let firstarr = [];
      values.map((val) => {
        if (firstarr.findIndex((v) => v.appBizType === val.appBizType) === -1) {
          let obj = {
            appBizType: val.appBizType,
            appBiztypeName: val.appBiztypeName,
            arr: new Array(),
          };
          firstarr.push(obj);
        }
      });
      firstarr.map((val) => {
        values.map((v) => {
          if (val.appBizType == v.appBizType) {
            val.arr.push(v);
          }
        });
      });

      return firstarr;
    },
    /**
     * 菜单过滤 By kongxiangcheng
     */
    filterMenu(values) {
      let menuArr = [];
      values.map((v) => {
        if (
          v.appBizType == "dataDashboard" ||
          v.appBizType == "stateQuery" ||
          v.appBizType == "busiHandle" ||
          v.appBizType == "paramQuery" ||
          v.appBizType == "subscriptionPush"
        ) {
          menuArr.push(v);
        }
      });
      return menuArr;
    },
  },
  components: {
    Headerd,
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Sticky.name]: Sticky,
    [Col.name]: Col,
    [Row.name]: Row,
    [CollapseItem.name]: CollapseItem,
    [Collapse.name]: Collapse,
  },
};
</script>

<style scoped lang="scss">
</style>

